import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { catchError, map } from "rxjs";
import { DropDownList } from "src/app/admin/models/common/drop-down-list";
import { RequestAdminSearchDto } from "src/app/admin/models/donor-request-admin";
import { DonorRequestAdminService } from "src/app/admin/services/donor-request-admin.service";
import { BaseComponent } from "src/app/shared/base/base-component";
import { DatepickerGregorianComponent } from "src/app/shared/components/datepicker-gregorian/datepicker-gregorian.component";
import { DatepickerUmalquraComponent } from "src/app/shared/components/datepicker-umalqura/datepicker-umalqura.component";
import { MomentTransformType } from "src/app/shared/models/enums";
import { IDate } from "src/app/shared/models/models";
import { MomentPipe } from "src/app/shared/pipes/moment.pipe";

@Component({
  selector: "app-donor-request-admin-filter",
  templateUrl: "./donor-request-admin-filter.component.html",
  styleUrls: ["./donor-request-admin-filter.component.scss"],
})
export class DonorRequestAdminFilterComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  @ViewChild("datePickerFromGregorian")
  datePickerFromGregorian: DatepickerGregorianComponent;
  @ViewChild("datePickerFromHijri")
  datePickerFromHijri: DatepickerUmalquraComponent;

  @ViewChild("datePickerToHijri")
  datePickerToHijri: DatepickerUmalquraComponent;
  @ViewChild("datePickerToGregorian")
  datePickerToGregorian: DatepickerGregorianComponent;
  @Input() searchModel: RequestAdminSearchDto;
  @Output() model = new EventEmitter<RequestAdminSearchDto | null>();
  requestGregStartDate: any;
  requestGregEndDate: any;
  isHijriDate: boolean = false;
  errorMessage: string;
  filterDateValidation: boolean = true;
  public requestTypes: DropDownList<number, string>[];
  public requestStatus: DropDownList<number, string>[];
  constructor(
    private fb: FormBuilder,
    private service: DonorRequestAdminService,
    private momentPipe: MomentPipe
  ) {
    super();
  }
  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }

  ngOnInit(): void {
    this.createForm();
    this.getRequestTypes();
    this.getRequestStatus();
  }
  private createForm() {
    this.formGroup = this.fb.group({
      fromDate: [this.searchModel?.fromDate],
      toDate: [this.searchModel?.toDate],
      requestType: [this.searchModel?.requestType],
      requestStatus: [this.searchModel?.requestStatus],
    });

    this.formGroup.statusChanges.subscribe(() => {
      /* console.log("test ", result)*/
    });
  }
  selectStartDate(event: any) {
    // if (this.isHijriDate) {
    //   this.formGroup.controls["startDate"].setValue(
    //     this.datePickerFromHijri.form.controls["date"].value
    //   );
    // } else {
    //   this.formGroup.controls["startDate"].setValue(
    //     this.datePickerFromGregorian.form.controls["date"].value
    //   );
    // }
    this.filterDateValidation = true;
    if (this.isHijriDate) {

      if (this.datePickerToHijri.form.controls["date"].value != "") {
        let dateFrom = new Date(this.datePickerFromHijri.form.controls["date"].value.year + " " + this.datePickerFromHijri.form.controls["date"].value.month + " " + this.datePickerFromHijri.form.controls["date"].value.day);
        let dateTo = new Date(this.datePickerToHijri.form.controls["date"].value.year + " " + this.datePickerToHijri.form.controls["date"].value.month + " " + this.datePickerToHijri.form.controls["date"].value.day);

        if (dateFrom > dateTo) {
          this.filterDateValidation = false;
        }
        else {
          this.filterDateValidation = true;
        }
      }
    }
    else {
      if (this.datePickerToGregorian.form.controls["date"].value != "") {
        let dateFrom = new Date(this.datePickerFromGregorian.form.controls["date"].value.year + " " + this.datePickerFromGregorian.form.controls["date"].value.month + " " + this.datePickerFromGregorian.form.controls["date"].value.day);
        let dateTo = new Date(this.datePickerToGregorian.form.controls["date"].value.year + " " + this.datePickerToGregorian.form.controls["date"].value.month + " " + this.datePickerToGregorian.form.controls["date"].value.day);
        if (dateFrom > dateTo) {
          this.filterDateValidation = false;
        }
        else {
          this.filterDateValidation = true;
        }
      }
    }
  }

  selectEndDate(event: any) {
    // if (this.isHijriDate) {
    //   this.formGroup.controls["endDate"].setValue(
    //     this.datePickerToHijri.form.controls["date"].value
    //   );
    // } else {
    //   this.formGroup.controls["endDate"].setValue(
    //     this.datePickerToGregorian.form.controls["date"].value
    //   );
    // }
    this.filterDateValidation = true;
    if (this.isHijriDate) {

      if (this.datePickerFromHijri.form.controls["date"].value != "") {
        let dateFrom = new Date(this.datePickerFromHijri.form.controls["date"].value.year + " " + this.datePickerFromHijri.form.controls["date"].value.month + " " + this.datePickerFromHijri.form.controls["date"].value.day);
        let dateTo = new Date(this.datePickerToHijri.form.controls["date"].value.year + " " + this.datePickerToHijri.form.controls["date"].value.month + " " + this.datePickerToHijri.form.controls["date"].value.day);

        if (dateFrom > dateTo) {
          this.filterDateValidation = false;
        }
        else {
          this.filterDateValidation = true;
        }
      }
    }
    else {
      if (this.datePickerFromGregorian.form.controls["date"].value != "") {
        let dateFrom = new Date(this.datePickerFromGregorian.form.controls["date"].value.year + " " + this.datePickerFromGregorian.form.controls["date"].value.month + " " + this.datePickerFromGregorian.form.controls["date"].value.day);
        let dateTo = new Date(this.datePickerToGregorian.form.controls["date"].value.year + " " + this.datePickerToGregorian.form.controls["date"].value.month + " " + this.datePickerToGregorian.form.controls["date"].value.day);
        if (dateFrom > dateTo) {
          this.filterDateValidation = false;
        }
        else {
          this.filterDateValidation = true;
        }
      }
    }
  }
  public onFilter() {
    if (!this.searchModel) this.searchModel = {} as RequestAdminSearchDto;
    const data = this.form_Group.controls;
    const { startDate, endDate } = this.ParseDatesFromDatePickers();

    this.searchModel.fromDate = startDate;
    this.searchModel.toDate = endDate;
    this.searchModel.requestType = data["requestType"].value;
    this.searchModel.requestStatus = data["requestStatus"].value;

    this.model.emit(this.searchModel);
  }
  public resetForm() {
    this.searchModel.fromDate = null;
    this.searchModel.toDate = null;
    if (this.isHijriDate) {
      this.datePickerFromHijri.form.controls["date"].setValue("");
      this.datePickerToHijri.form.controls["date"].setValue("");
    } else {
      this.datePickerFromGregorian.form.controls["date"].setValue("");
      this.datePickerToGregorian.form.controls["date"].setValue("");
    }
    this.isHijriDate = false;
    this.searchModel.requestType = null;
    this.searchModel.requestStatus = null;
    this.filterDateValidation = true;
    this.createForm();
  }
  public getRequestTypes(): void {
    const sub = this.service
      .GetRequestTypesDDL()
      .pipe(
        map((response: DropDownList<number, string>[]) => {
          if (response) {
            this.requestTypes = response;
          }
        }),
        catchError((err) => {
          return this.logException(err);
        })
      )
      .subscribe();

    this.subscription.push(sub);
  }
  public getRequestStatus(): void {
    const sub = this.service
      .GetRequestStatusDDL()
      .pipe(
        map((response: DropDownList<number, string>[]) => {
          if (response) {
            this.requestStatus = response;
          }
        }),
        catchError((err) => {
          return this.logException(err);
        })
      )
      .subscribe();

    this.subscription.push(sub);
  }
  private ParseDatesFromDatePickers(): {
    startDate: any;
    endDate: any;
  } {
    let ngsbDate: IDate = this.isHijriDate
      ? this.datePickerFromHijri.form.controls["date"].value
      : this.datePickerFromGregorian.form.controls["date"].value;

    let ngebDate = this.isHijriDate
      ? this.datePickerToHijri.form.controls["date"].value
      : this.datePickerToGregorian.form.controls["date"].value;

    let startDateString = !ngsbDate
      ? null
      : ngsbDate.year + "/" + ngsbDate.month + "/" + ngsbDate.day + " 10:00:00";
    let endDateString = !ngebDate
      ? null
      : ngebDate.year + "/" + ngebDate.month + "/" + ngebDate.day + " 10:00:00";

    if (this.isHijriDate) {
      let startDate = this.momentPipe.transform(
        startDateString,
        MomentTransformType.ToGregorianIsoStringFormatFromHijri
      );
      let endDate = this.momentPipe.transform(
        endDateString,
        MomentTransformType.ToGregorianIsoStringFormatFromHijri
      );
      return {
        startDate: startDate == "Invalid date" ? null : startDate,
        endDate: endDate == "Invalid date" ? null : endDate,
      };
    } else {
      let startDate = this.momentPipe.transform(
        startDateString,
        MomentTransformType.ToGregorianIsoStringFormat
      );
      let endDate = this.momentPipe.transform(
        endDateString,
        MomentTransformType.ToGregorianIsoStringFormat
      );
      return {
        startDate: startDate == "Invalid date" ? null : startDate,
        endDate: endDate == "Invalid date" ? null : endDate,
      };
    }
  }
}
